import Typography from '@mui/material/Typography'
import LinearProgress from '@mui/material/LinearProgress'
import { Col, Row } from 'reactstrap'
import { useOnboarding } from '../OnboardingContext'
import { useEffect, useState } from 'react'

const FileWorker = (context) => {
    const { files, setFiles, filesCurrentAction, setFilesCurrentAction, onboardingInputUrl } = useOnboarding()
    const [fileIndexToUpload, setFileIndexToUpload] = useState(0)
    const [token] = useState(new URLSearchParams(window.location.search).get("token"))

    function updateFile(filename, newStatus, newProgress, color) {
        const newFiles = files.map((f) => {
            if (f.name === filename) {
                return {...f, name: filename, status: newStatus, progress: newProgress, color: color ? color : 'primary'}
            }
            return f
        })
        
        setFiles(newFiles)
    }   

    const upload = () => {
        const f = {}
        f.filename = files[fileIndexToUpload].name
        f.filesize = files[fileIndexToUpload].size
        f.user = "onboarding"
        f.filetype = files[fileIndexToUpload].type

        const reader = new FileReader()
        reader.onload = event => {
          const fileContent = event.target.result
          f.file = fileContent
          updateFile(files[fileIndexToUpload].name, "Uploading", 5)

          const apiURL = `${onboardingInputUrl}/input/file?token=${token}`
          fetch(apiURL, {method: 'POST', body: JSON.stringify(f)}).then(response => {
            console.log(response.status)
            if (response.status !== 200 && response.status !== 201) {
                console.log('error')
                updateFile(files[fileIndexToUpload].name, response.err ? response.err : "Error", 100, 'error')
            } else {
                updateFile(files[fileIndexToUpload].name, "Done", 100, 'success')
            }
          })
          .catch(err => updateFile(files[fileIndexToUpload].name, err, 100, 'error'))  
          .finally(() => {
            if (fileIndexToUpload + 1 >= files.length) {
                setFilesCurrentAction("done")
            } else {
                setFileIndexToUpload(prev => prev + 1)
            }
          })
        }
        reader.readAsText(files[fileIndexToUpload])
    }

    const columnStyle = {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column'
    }

    useEffect(() => {
        if (filesCurrentAction === "upload" && !context.readonly) {
            console.log(`start upload file index ${fileIndexToUpload}`)
            upload()
        }
    }, [filesCurrentAction, fileIndexToUpload])

    return (
        <>
        {files.map(f => {
            return (
            <Row key={`${f.name}-${f.status}`}>
                <Col md='3' style={columnStyle}>
                    <Typography sx={{ mt: '100px' }} className='mt-1'>{ f.name }</Typography>
                </Col>
                <Col md='8' style={columnStyle}>
                    <LinearProgress variant={f.status === "" || f.status === undefined ? 'indeterminate' : 'determinate'} value={f.progress ? f.progress : 0} color={f.color ? f.color : 'primary'} />
                </Col>
                <Col md='1' style={columnStyle}>
                    <Typography variant='body2' color='text.secondary' className='mt-1'>{ f.status }</Typography>
                </Col>
            </Row>)
        })}
        </>
    )
}

export default FileWorker